function o(n) {
  return `<html><head><script>function step1(){
setTimeout('step2()', 10);}
function step2(){window.print();window.close()}
<\/script></head><body onload='step1()'>
<img src='` + n + `' width="100%" height="100%" /></body></html>`;
}
function e(n) {
  const t = window.open("about:blank", "_new");
  t.document.open(), t.document.write(o(n)), t.document.close();
}
export {
  e as HtmlWindowPrintImage,
  o as ImagetoPrint
};
//# sourceMappingURL=index16.js.map
